import { memo } from 'react';
import { Box, Text, Button, Icon } from '@bonanza-social/moonlight';
import { BottomSheetExtendedProps } from '@bonanza-social/navigation';

function Maintenance({ close }: BottomSheetExtendedProps) {
  return (
    <Box gap="space-400" alignItems="center" flexDirection="column">
      <Icon name="maintenance" width={80} height={80} />

      <Text
        variant="h3"
        locKey="maintenanceTitle"
        locNS="common"
        color="darkSurfacePrimary"
        textAlign="center"
      />

      <Text
        variant="body-l"
        locKey="maintenanceDescription"
        locNS="common"
        color="darkSurfacePrimary"
        textAlign="center"
      />
      <Button
        variant="primary"
        locKey="gotIt"
        locNS="common"
        size="large"
        width="100%"
        onPress={close}
        backgroundColor="accentBackground"
      />
    </Box>
  );
}

export default memo(Maintenance);
